// extracted by mini-css-extract-plugin
export default {"unpacking_box":"UnpackingLink-module--unpacking_box--XZuw2","amount_packs":"UnpackingLink-module--amount_packs--7tCxa","pulse":"UnpackingLink-module--pulse--7UadP"};